import { inject, Injectable } from '@angular/core';

import { NotificationService } from '@blaze-shared/platform-data-access';

@Injectable({ providedIn: 'root' })
export class ElementDataTypeActionsService {
  private notificationService = inject(NotificationService);

  copy(value?: string): void {
    if (!value) {
      return;
    }

    navigator.clipboard.writeText(value);
    this.notificationService.success(`Copied ${value}`, true);
  }

  openPage(url?: string): void {
    if (!url) {
      return;
    }

    window.open(url, '_blank', 'noreferrer noopener');
  }
}
